import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Star } from "lucide-react";
import { SITE, NAV, BRANDS } from "@/mock";

export default function Footer() {
  return (
    <footer className="bg-neutral-900 text-neutral-300">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 px-4 pb-12 pt-8 sm:gap-10 sm:px-6 sm:py-14 md:grid-cols-4 lg:px-8">
        <div>
          <img src={SITE.logo} alt="MattressTown" className="mb-4 hidden h-10 w-auto md:block" />
          <p className="text-sm leading-relaxed text-neutral-400">
            {SITE.tagline}. Family-owned and operated, offering premium brands,
            honest pricing and same-day delivery.
          </p>
          <a
            href={SITE.googleReviewUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-white hover:text-[#ff3b52]"
          >
            <Star className="h-4 w-4 fill-amber-400 text-amber-400" aria-hidden="true" />
            {SITE.rating.toFixed(1)} · {SITE.reviewCount} Google Reviews
          </a>
        </div>

        <nav aria-label="Footer shop" className="hidden md:block">
          <h3 className="mb-4 text-sm font-bold uppercase tracking-widest text-white">Shop</h3>
          <ul className="space-y-2 text-sm">
            {NAV.slice(0, 4).map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="hover:text-[#ff3b52]">{n.label}</Link>
              </li>
            ))}
            {BRANDS.slice(0, 2).map((b) => (
              <li key={b.slug}>
                <Link to={`/brands/${b.slug}`} className="hover:text-[#ff3b52]">{b.name}</Link>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label="Footer company" className="hidden md:block">
          <h3 className="mb-4 text-sm font-bold uppercase tracking-widest text-white">Company</h3>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-[#ff3b52]">About Us</Link></li>
            <li><Link to="/services" className="hover:text-[#ff3b52]">Delivery &amp; Services</Link></li>
            <li><Link to="/locations" className="hover:text-[#ff3b52]">Locations</Link></li>
            <li><Link to="/reviews" className="hover:text-[#ff3b52]">Reviews</Link></li>
            <li><Link to="/contact" className="hover:text-[#ff3b52]">Contact Us</Link></li>
            <li><Link to="/accessibility-statement" className="hover:text-[#ff3b52]">Accessibility Statement</Link></li>
          </ul>
        </nav>

        <div>
          <h3 className="mb-4 text-sm font-bold uppercase tracking-widest text-white">Visit Our Showroom</h3>
          <address className="space-y-3 text-sm not-italic text-neutral-400">
            <a href={SITE.address.mapsUrl} target="_blank" rel="noopener noreferrer" className="flex items-start gap-2 hover:text-[#ff3b52]">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
              {SITE.address.full}
            </a>
            <a href={SITE.phoneHref} className="flex items-center gap-2 hover:text-[#ff3b52]">
              <Phone className="h-4 w-4 shrink-0" aria-hidden="true" /> {SITE.phone}
            </a>
            <a href={`mailto:${SITE.email}`} className="flex items-center gap-2 hover:text-[#ff3b52]">
              <Mail className="h-4 w-4 shrink-0" aria-hidden="true" /> {SITE.email}
            </a>
            <div className="flex items-start gap-2">
              <Clock className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
              <ul>
                {SITE.hours.map((h) => (
                  <li key={h.day}>{h.day}: {h.time}</li>
                ))}
              </ul>
            </div>
          </address>
        </div>
      </div>

      <div className="border-t border-neutral-800">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-6 text-xs text-neutral-500 sm:flex-row sm:px-6 lg:px-8">
          <p>© {new Date().getFullYear()} {SITE.name}. All rights reserved.</p>
          <p>
            Website Designed By{" "}
            <a
              href="https://bp.agency"
              target="_blank"
              rel="noopener noreferrer"
              className="font-bold text-white underline decoration-[#ff3b52] underline-offset-2 hover:text-[#ff3b52]"
            >
              Brand Partners
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
